import { type FunctionComponent, type ReactElement, useCallback, useEffect, useMemo } from "react";

import { useFallbackStorageValue } from "shared/hooks/fallback-storage-value";

import { AISearchTooltipLocalStorageKey } from "./consts";
import IconClose from "./icon-close.svg";
import { CloseButton, Message, MessageContainer, NewBadge, StyledTooltip } from "./styles";

type Props = {
  children: ReactElement;
  onClose?: () => void;
  visible?: boolean;
};

export const HeaderFeaturesSearchBarTooltip: FunctionComponent<Props> = ({
  children,
  onClose,
  visible = true,
}) => {
  const { set: setDismissed, value: isDismissed } = useFallbackStorageValue(
    AISearchTooltipLocalStorageKey,
    { defaultValue: "false" },
  );

  const isOpen = useMemo(() => visible && isDismissed === "false", [isDismissed, visible]);

  const handleClick = useCallback(() => {
    setDismissed("true");
    onClose?.();
  }, [onClose, setDismissed]);

  useEffect(() => {
    if (isDismissed === "true") onClose?.();
  }, [isDismissed, onClose]);

  return (
    <StyledTooltip
      arrow
      open={isOpen}
      placement="bottom-start"
      slotProps={{
        popper: {
          disablePortal: true,
        },
      }}
      title={
        <MessageContainer>
          <NewBadge>NEW</NewBadge>
          <CloseButton onClick={handleClick}>
            <IconClose />
          </CloseButton>
          <Message>
            Search the way you think. Try our AI-powered search to find news faster.
          </Message>
        </MessageContainer>
      }
    >
      {children}
    </StyledTooltip>
  );
};

HeaderFeaturesSearchBarTooltip.displayName = "HeaderFeaturesSearchBarTooltip";
